<template>
    <v-container fluid>
        <PageHeaderSlot :isLoading="$store.getters.isLoading"> </PageHeaderSlot>
        <v-row>
            <v-col cols="12">
                <v-btn depressed color="primary accent-4" class="white--text" :to="{ name: 'CreateNews' }"> Add </v-btn>
            </v-col>
            <v-col cols="12">
                <Datatable
                    :isLoading="tableLoading"
                    :tableHeaders="tableHeaders"
                    :tableData="tableData"
                    :page="tablePage"
                    :pageLimit="tableLimit"
                    :itemTotal="tableItemTotal"
                    @options-update="onTableOptionsChange($event)"
                    @delete-clicked="handleDelete($event)"
                    actionViewRouteLink="NewsDetails"
                ></Datatable>
            </v-col>
        </v-row>

        <ConfirmDialog
            ref="deleteDialog"
        ></ConfirmDialog>
    </v-container>
</template>
  
<script>
import { mapActions } from 'vuex';
import Datatable from '@/components/Datatable.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';

export default {
    name: 'NewsList',
    components: {
        Datatable,
        ConfirmDialog
    },
    data: () => ({
        tableLoading: false,
        tableData: [],
        tablePage: 1,
        tableLimit: 10,
        tableItemTotal: 0,

        // --- static data
        tableHeaders: [
            { text: 'Create Date', value: 'create_date', width: 200 },
            { text: 'Title', value: 'title' },
            { text: '', value: 'actionViewDelete', width: 240 },
        ],
    }),

    methods: {
        ...mapActions(['setDialogMessage', 'setShowDialog', 'setLeaveDialogLink', 'setShowLeaveDialog']),
        async getNewsData() {
            this.tableLoading = true;
            try {
               const payload = {
                limit: this.tableLimit,
                page: this.tablePage - 1
               };

               const { data, total } = await this.$Fetcher.GetNews(payload);
               this.tableItemTotal = total;
               this.tableData = data.map(item => {
                return {
                    id: item.id,
                    create_date: item.create_date,
                    title: item.title
                }
               })
            } catch (err) {
                this.$common.error(err);
            } finally {
                this.tableLoading = false;
            }
        },

        onTableOptionsChange(options) {
            if (options.itemsPerPage !== this.tableLimit) {
                this.tablePage = 1; // reset to first page if view options changed
            } else {
                this.tablePage = options.page;
            }

            this.tableLimit = options.itemsPerPage;
            this.getNewsData();
        },

        async handleDelete(id) {
            if (this.$store.getters.isLoading) {
                this.$store.dispatch('toggleAlertMessage', {
                    show: true,
                    message: 'processing',
                    type: 'error',
                    refresh: false,
                    redirect: ''
                });
                return;
            }

            const confirm = await this.$refs['deleteDialog'].show();
            if (confirm === true) {
                this.$store.dispatch('setLoading', true);
                try {
                    await this.$Fetcher.DeleteNewsById(id);
                    this.$store.dispatch('toggleAlertMessage', {
                        show: true,
                        message: 'Deleted Successfully',
                        type: 'success',
                        refresh: false,
                        redirect: ''
                    });

                    this.getNewsData();
                } catch (err) {
                    this.setDialogMessage({
                        title: "Deleted Fail",
                        message: err,
                        isError: true,
                        returnLink: null,
                    });
                    this.setShowDialog(true);
                } finally {
                      this.$store.dispatch('setLoading', false);
                }
            }
        },
    },
    async created() {
        this.getNewsData();
    },

    // ------ navigation guard ------
    beforeRouteLeave(to, from, next) {
        if (this.$store.getters.isLoading) {
            this.$store.dispatch('toggleAlertMessage', {
                show: true,
                message: 'processing',
                type: 'error',
                refresh: false,
                redirect: ''
            });
            next(false);
        } else if (this.$store.getters.dataIsUpdated) {
            this.setLeaveDialogLink({ name: to.name });
            this.setShowLeaveDialog(true);
            next(false);
        } else {
            next();
        }
    },
}
</script>
  